import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { X } from "lucide-react";
import AppButton from "../../../common_components/AppButton";
import { NumberInput, TextArea } from "../../../common_components/FormInputs";
const BUTTON_SX = {
    minWidth: 120,
    height: 36,
    minHeight: 36,
    px: "14px",
    borderRadius: "8px",
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    boxShadow: "0px 1px 2px 0px #0A0D120D",
};
const BillingSummaryDetailsModal = ({ open, clientName, initialTotalCommissions, initialInvoiceSalesDescription, saving = false, onSave, onClose, }) => {
    const [totalCommissions, setTotalCommissions] = useState(initialTotalCommissions);
    const [invoiceSalesDescription, setInvoiceSalesDescription] = useState(initialInvoiceSalesDescription);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (!open)
            return;
        setTotalCommissions(initialTotalCommissions);
        setInvoiceSalesDescription(initialInvoiceSalesDescription);
    }, [open, initialTotalCommissions, initialInvoiceSalesDescription]);
    const handleSave = () => {
        const next = {};
        if (!totalCommissions || String(totalCommissions).trim() === "")
            next.totalCommissions = "Total Commissions is required.";
        if (!invoiceSalesDescription || invoiceSalesDescription.trim() === "")
            next.invoiceSalesDescription = "Invoice Sales Description is required.";
        if (Object.keys(next).length) {
            setErrors(next);
            return;
        }
        setErrors({});
        onSave(totalCommissions, invoiceSalesDescription);
    };
    if (!open)
        return null;
    return (_jsx(Dialog, { open: open, maxWidth: "sm", fullWidth: true, disableEscapeKeyDown: true, className: "dialog-popup-container", sx: {
            zIndex: 2000,
            "& .MuiBackdrop-root": {
                backgroundColor: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(3px)",
            },
            "& .MuiDialog-container > .MuiPaper-root": { borderRadius: "12px" },
        }, children: _jsxs(DialogContent, { sx: { p: 0 }, children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 2,
                        px: 3,
                        py: 2,
                        borderBottom: "1px solid #EAECF0",
                    }, children: [_jsxs(Box, { children: [_jsx(Typography, { sx: { fontSize: "18px", fontWeight: 600, color: "#101828", lineHeight: "28px" }, children: "Invoice Details" }), _jsx(Typography, { sx: { fontSize: "14px", color: "#667085", lineHeight: "20px", mt: 0.25 }, children: clientName || "Add invoice details for this client" })] }), _jsx(IconButton, { onClick: onClose, disabled: saving, sx: { width: 36, height: 36, color: "#98A2B3", "&:hover": { color: "#475467", bgcolor: "#F9FAFB" } }, children: _jsx(X, { size: 20 }) })] }), _jsxs(Box, { sx: { bgcolor: "#F9FAFB", px: 3, py: 3, display: "grid", gap: 2 }, children: [_jsx(NumberInput, { label: "Total Commissions", required: true, value: totalCommissions, onChange: (event) => {
                                setTotalCommissions(event.target.value);
                                if (errors.totalCommissions)
                                    setErrors((prev) => ({ ...prev, totalCommissions: undefined }));
                            }, size: "md", fullWidth: true, allowDecimal: true, step: 0.01, error: Boolean(errors.totalCommissions), errorMessage: errors.totalCommissions }), _jsx(TextArea, { label: "Invoice Sales Description", required: true, value: invoiceSalesDescription, onChange: (event) => {
                                setInvoiceSalesDescription(event.target.value);
                                if (errors.invoiceSalesDescription)
                                    setErrors((prev) => ({ ...prev, invoiceSalesDescription: undefined }));
                            }, minRows: 2, size: "md", fullWidth: true, error: Boolean(errors.invoiceSalesDescription), errorMessage: errors.invoiceSalesDescription }), _jsxs(Box, { sx: { display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1, flexWrap: "wrap" }, children: [_jsx(AppButton, { variant: "contained", color: "inherit", onClick: handleSave, disabled: saving, sx: {
                                        ...BUTTON_SX,
                                        bgcolor: "#181D27",
                                        color: "#fff",
                                        border: "1px solid #181D27",
                                        "&:hover": { bgcolor: "#101828", border: "1px solid #101828" },
                                    }, children: "Save" }), _jsx(AppButton, { variant: "contained", color: "inherit", onClick: onClose, disabled: saving, sx: {
                                        ...BUTTON_SX,
                                        bgcolor: "#fff",
                                        color: "#414651",
                                        border: "1px solid #D5D7DA",
                                        "&:hover": { bgcolor: "#F9FAFB", border: "1px solid #D5D7DA" },
                                    }, children: "Close" })] })] })] }) }));
};
export default BillingSummaryDetailsModal;
